export default function auth({ next, router }) {
  if (!sessionStorage.getItem('sanctum_auth')) {
    return router.push({ name: 'auth-login' })
  }

  return next()
}
